import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import * as React from 'react'
import ReactDOM from 'react-dom'

import {
  ChartLayoutWithGlobalState,
  FREE_DATE_RANGES,
  Quote,
  RootChartConfigObject,
  Theme,
} from '../../../../app/charts-lib'
import { decodeQueryString } from '../../../../app/queryString'
import { getInitChartConfig } from '../../../../app/shared/getInitChartConfig'
import { SpecificChartFunctionality, TIMEFRAME } from '../../../constants'
import { initIdeaQuotes } from '../../charts/util'
import { getChartLayoutSizeConfig, useChartLayoutWidthWatch } from '../hooks/use-chart-layout-width-watch'

function initChartConfig() {
  if (window.globalChartConfig.didInit) return

  if (FinvizSettings.quoteData) {
    Quote.create(FinvizSettings.quoteData)
  }

  if (window.globalChartConfig && !window.globalChartConfig.idea) {
    window.globalChartConfig = getInitChartConfig()
  }

  if (window.globalChartConfig?.ideaQuotes) {
    initIdeaQuotes(window.globalChartConfig.ideaQuotes, window.globalChartConfig)
  }

  window.globalChartConfig.didInit = true
}

function getInitialChartConfig(): RootChartConfigObject {
  initChartConfig()

  const theme = FinvizSettings.hasDarkTheme ? Theme.dark : Theme.light
  return {
    ...window.globalChartConfig,
    specificChartFunctionality: SpecificChartFunctionality.quotePage,
    charts: window.globalChartConfig.charts.map((chart) => ({
      ...chart,
      dateRange:
        FinvizSettings.hasUserPremium || FREE_DATE_RANGES.includes(chart.dateRange ?? '') ? chart.dateRange : null,
    })),
    theme,
  }
}

export function QuoteChart({ configOverride }: { configOverride?: Partial<RootChartConfigObject> }) {
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  useChartLayoutWidthWatch()

  const config = React.useMemo(() => {
    if (!window.globalChartConfig) return

    const { p = FinvizSettings.defaultPeriod } = decodeQueryString()
    const initialConfig = getInitialChartConfig()
    const sizeConfig = getChartLayoutSizeConfig(window.globalChartConfig, p as TIMEFRAME)

    return { ...initialConfig, ...sizeConfig, ...configOverride }
  }, [configOverride])

  if (!config || !chartEl) return null

  return ReactDOM.createPortal(<ChartLayoutWithGlobalState parentElement={chartEl} config={config} />, chartEl)
}
